export const RESET_STATE = "RESET_STATE";
export const SET_PROPERTIES = "SET_PROPERTIES";
export const SET_AGENTS_QUEUE = "SET_AGENTS_QUEUE";
